import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Search, Users, Briefcase, CreditCard, MessageSquare, User, Compass,
  FileText, FileSignature, LogOut, Command,
} from "lucide-react";

const CLIENT_NAV = [
  { to: "/client", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/client/searches", label: "My Searches", icon: Search },
  { to: "/client/jobs", label: "Job Postings", icon: Briefcase },
  { to: "/client/contracts", label: "Contracts", icon: FileSignature },
  { to: "/client/billing", label: "Billing", icon: CreditCard },
  { to: "/client/messages", label: "Messages", icon: MessageSquare },
];

const CANDIDATE_NAV = [
  { to: "/candidate", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/candidate/opportunities", label: "Opportunities", icon: Compass },
  { to: "/candidate/applications", label: "My Applications", icon: FileText },
  { to: "/candidate/profile", label: "My Profile", icon: User },
  { to: "/candidate/messages", label: "Messages", icon: MessageSquare },
];

export default function PortalLayout({ variant }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const nav = variant === "client" ? CLIENT_NAV : CANDIDATE_NAV;
  const label = variant === "client" ? "Client Portal" : "Candidate Portal";

  const handleLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <aside className="w-60 shrink-0 border-r border-black/10 flex flex-col fixed h-screen bg-white z-20">
        <Link to="/" className="h-16 flex items-center gap-2 px-5 border-b border-black/10">
          <div className="h-7 w-7 bg-primary flex items-center justify-center">
            <Command className="h-4 w-4 text-white" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <p className="font-heading font-black text-sm tracking-tight">INNOVATION</p>
            <p className="overline text-[0.55rem] leading-none">{label}</p>
          </div>
        </Link>
        <nav className="flex-1 py-4 flex flex-col gap-0.5 px-3">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`pnav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors duration-150 ${
                  isActive ? "bg-[#09090B] text-white" : "text-muted-foreground hover:text-[#09090B] hover:bg-black/5"
                }`
              }
            >
              <item.icon className="h-4 w-4" strokeWidth={1.5} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-black/10 p-3">
          <div className="px-2 py-2 mb-1">
            <p className="text-sm font-medium truncate">{user?.full_name}</p>
            <p className="overline text-[0.55rem]">{user?.role}</p>
          </div>
          <button onClick={handleLogout} data-testid="logout-btn"
            className="flex items-center gap-3 px-3 py-2.5 text-sm w-full text-muted-foreground hover:text-[#09090B] hover:bg-black/5 transition-colors duration-150">
            <LogOut className="h-4 w-4" strokeWidth={1.5} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-h-screen"><Outlet /></main>
    </div>
  );
}
